import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    signatureLink: String,
    clientId: Number,
    isSandbox: Boolean
  }

  connect() {
    if (!this.signatureLinkValue) {
      console.error("[yousign-iframe] signatureLink manquant")
      return
    }
    if (!window.Yousign) {
      console.error("[yousign-iframe] SDK Yousign introuvable (script CDN non chargé)")
      return
    }

    this._submitted = false

    this.yousign = new window.Yousign({
      signatureLink: this.signatureLinkValue,
      iframeContainerId: this.element.id,
      isSandbox: this.isSandboxValue
    })

    if (typeof this.yousign.onSuccess === "function") {
      this.yousign.onSuccess(() => this.submitOnce())
    }
    if (typeof this.yousign.on === "function") {
      this.yousign.on("signature.done", () => this.submitOnce())
      this.yousign.on("signature.success", () => this.submitOnce())
    }
  }

  submitOnce() {
    if (this._submitted) return
    this._submitted = true

    const form = document.getElementById("apply-subscription-form")
    if (form) form.requestSubmit()
  }
}